import BaseModel from './BaseModel';
export default class TicketSold extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.serialNumber = data.serialNumber || this.translate.serialNumber || undefined;
        this.skuCode = data.skuCode || this.translate.skuCode || undefined;
        this.ticketCode = data.ticketCode || this.translate.ticketCode || undefined;
        this.productType = data.productType || this.translate.productType || undefined;
        this.stayStartDate = data.stayStartDate || this.translate.stayStartDate || undefined;
        this.stayEndDate = data.stayEndDate || this.translate.stayEndDate || undefined;
        this.operaBooking = data.operaBooking || this.translate.operaBooking || undefined;
        this.status = data.status || this.translate.status || undefined;
        this.isLocked = data.isLocked || this.translate.isLocked || undefined;
        this.note = data.note || this.translate.note || undefined;
        this.originalPrice = data.originalPrice || this.translate.originalPrice || undefined;
        this.salePrice = data.salePrice || this.translate.salePrice || undefined;
        this.saleDate = data.saleDate || this.translate.saleDate || undefined;
        this.propertyId = data.propertyId || this.translate.propertyId || undefined;
        this.rateCode = data.rateCode || this.translate.rateCode || undefined;
        this.rateCodeId = data.rateCodeId || this.translate.rateCodeId || undefined;
        this.tourCode = data.tourCode || this.translate.tourCode || undefined;
        this.tourName = data.tourName || this.translate.tourName || undefined;
        this.objectType = data.objectType || this.translate.objectType || undefined;
        this.verifyCode = data.verifyCode || this.translate.verifyCode || undefined;
        this.propertyName = data.propertyName || this.translate.propertyName || undefined;
        this.redeemProperty = data.redeemProperty || undefined;
        this.properties = data.properties || []
    }

    export(hasTranslate = false) {
        const result = super.export({
            serialNumber: this.serialNumber,
           
        });
        if (hasTranslate) result.translate = () => {
            return {
                serialNumber: this.translate.serialNumber
            }
        }
        return result;
    }

}
